import { getSampleDocument, isIdCard } from '@pages/onboarding/kyc/utils'
import { Button, Modal } from 'gokwik-ui-kit'

const SampleDocumentPreview = ({ isOpen, setIsOpen, previewDoc, setPreviewDoc }) => {
    const onClose = () => {
        setPreviewDoc({})
        setIsOpen(false)
    }

    return (
        <Modal open={isOpen} footer={null} width={700} onCancel={onClose} title={'Sample Document'}>
            <div
                style={{
                    marginTop: '20px',
                    textAlign: 'center',
                    maxHeight: '300px',
                    overflowY: 'auto',
                }}
            >
                <img
                    src={getSampleDocument(previewDoc?.details?.name)}
                    alt={previewDoc?.title}
                    style={{
                        width: '100%',
                        height: isIdCard(previewDoc?.details?.name) ? '300px' : 'auto',
                        display: 'block',
                    }}
                />
            </div>
            <div className='flex justify-end align-middle' style={{ marginTop: '20px' }}>
                <Button type='primary' onClick={onClose}>
                    Understood
                </Button>
            </div>
        </Modal>
    )
}

export default SampleDocumentPreview
